'use client'

import { Fit, Layout, useRive } from '@rive-app/react-webgl2'
import { useEffect } from 'react'

export interface WorkflowBuildingAnimationProps {
  message?: string
}

export function WorkflowBuildingAnimation({ message }: WorkflowBuildingAnimationProps) {
  const { RiveComponent, rive } = useRive({
    src: '/animation/final-light.riv',
    stateMachines: 'State Machine 1',
    autoplay: true,
    layout: new Layout({ fit: Fit.FitHeight }),
  })

  useEffect(() => {
    if (rive) {
      rive.play()
    }
  }, [rive])

  useEffect(() => {
    return () => {
      if (rive) {
        rive.cleanup()
      }
    }
  }, [rive])

  return (
    <div className="flex w-full flex-col items-center gap-y-3">
      <div
        className="relative h-20 w-32"
        style={{
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
          maskImage:
            'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
        }}
      >
        <RiveComponent />
      </div>
      <div className="text-sm text-gray-600">
        {message || 'Just describe the work to be done in Sprites'}
      </div>
    </div>
  )
}
